<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left m-0">
            Upload Arquivo Afd
          </h4>

          <div class="tab-content" id="pills-tabContent" style="min-height: 100px;">
            <div class="tab-pane fade show active">
              <div class="row justify-content-center mt-2">

                <div class="row">
                  <el-select name="empregador" required class="select-success col-sm-12 pagination-select"
                    v-model="model.id_empregador" placeholder="Posto da Empresa">
                    <el-option v-for="item in listEmpregadores" :key="item.id" class="select-success" :label="item.local"
                      :value="item.id">{{ item.local }}</el-option>
                  </el-select>

                </div>

                <div class="row">
                  <div class="col-md-6 text-left">
                    <base-input label="Data Inicial" type="date" placeholder="dia/mês/ano" v-model="model.dataInicio">
                    </base-input>
                  </div>
                  <div class="col-md-6 text-left">
                    <base-input label="Data Final" type="date" placeholder="dia/mês/ano" v-model="model.dataFinal">
                    </base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 text-left">
                      <span class="fileinput-new">
                        {{ fileExists ? fileName : ''}}
                      </span>
                      <input ref="fileInput" @change="handlePreview" type="file" name="..." class="valid" :multiple="false"
                        aria-invalid="false" />
              
                    <base-button v-if="fileExists" @click="removeFile" type="danger" class="col-2">
                      <i class="fas fa-times"></i>
                    </base-button>
                  </div>
                </div>

              </div>
            </div>

          </div>


          <div class="row d-flex justify-content-end mt-3">
            <div class="col-sm-3 offset-6">
              <base-button block type="success" @click="sincronizarArquivo" :disabled="validateForm()">
                Sincronizar Arquivo
              </base-button>
            </div>
          </div>
        </card>
      </div>
    </div>
    
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" loader="spinner" color="#35a887" :is-full-page="true">
      </loading>
    </div>

  </div>
</template>
<script>
import { Card, BaseInput } from "@/components/index";
import Loading from "vue-loading-overlay";
import swal from "sweetalert2";
export default {

  components: {
    Loading,
    Card,
    BaseInput,
  },
  data() {
    return {
      fileName: "",
      isLoading: false,
      listEmpregadores: [],
      file: null,

      model: {
        id_empregador: "",
        dataInicio: "",
        dataFinal: "",
      },
    };
  },

  computed: {
    fileExists() {
      return this.fileName !== "" && this.fileName !== null;
    },
  },

  mounted() {
    this.listarEmpregadores();
  },

  methods: {

    handlePreview(event) {
      let file = event.target.files[0];
      if (!file) return;

      this.fileName = file.name;

      let that = this;

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        that.file = reader.result;
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },

    removeFile() {
      this.fileName = null;
      this.file = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
      this.$emit("change", null);
    },
    resetForm() {
      this.model.id_empregador = "";
      this.model.dataInicio = "";
      this.model.dataFinal = "";
      this.removeFile();
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },


    validateForm(){
      if(
        this.model.id_empregador
        && this.file
        && this.model.dataInicio
        && this.model.dataFinal
      ){
        return false;
      }else{
        return true;
      }
    },


    sincronizarArquivo(){
      this.isLoading = true;
      let th = this;
      
      let form = {
        "setDB": th.$cookies.get("db"),
        "id_empregador": th.model.id_empregador,
        "dataInicio": th.model.dataInicio,
        "dataFinal": th.model.dataFinal,
        "file": th.file,
      }
      
      this.axios.post("/api/sincronizando/arquivoAfd", form)
      .then((res) => {
        if (res.data.status == 'success') {
          th.showSwal(
            "auto-close",
            "Sucesso",
            `${res.data.message}`,
            "success"
          );
          th.resetForm();
        } else {
          th.showSwal(
            "auto-close",
            "Erro",
            `${res.data.err}`,
            "error"
          );
        }
        th.isLoading = false;
      })
      .catch((err) => {
        th.isLoading = false;
        th.showSwal(
          "auto-close",
          "Erro",
          err.response && err.response.data && err.response.data.err
            ? err.response.data.err
            : "Ocorreu algum erro ao sincronizar os pontos por arquivo!",
          "error"
        );
      });
    },

    listarEmpregadores() {
    let th = this;
    this.isLoading = true;

    let bodyFormData = {
      setDB: this.$cookies.get("db"),
    };
    this.axios
      .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
      .then((response) => {
        th.isLoading = false;
        th.listEmpregadores = response.data.data.dados;
      })
      .catch((err) => {
        console.log(err);
        th.isLoading = false;
        th.showSwal(
          "auto-close",
          "Erro",
          "Erro ao listar empresas!",
          "error"
        );
      });
  },

  },


};
</script>
